import z from 'zod';
import { customerRef } from './refs';
import { datetime, uuid } from './zod';
export var ShareConfigType;
(function (ShareConfigType) {
    ShareConfigType["PublicRead"] = "publicRead";
    ShareConfigType["Private"] = "private";
    ShareConfigType["Inherit"] = "inherit";
    ShareConfigType["Parents"] = "parents";
    ShareConfigType["Children"] = "children";
    ShareConfigType["Family"] = "family";
})(ShareConfigType || (ShareConfigType = {}));
export const shareConfig = z.object({
    type: z.nativeEnum(ShareConfigType),
    extra: customerRef.array().optional(),
});
export const defaultShareConfig = {
    type: ShareConfigType.Parents,
    extra: [],
};
export const entity = z.object({
    _id: uuid,
    createdAt: datetime,
    updatedAt: datetime,
    telluId: z.number().nullish(),
    migrationFinalised: z.boolean().nullish(),
    migrationFinalisedDate: datetime.nullish(),
});
export const scopedEntity = z.object({
    ...entity.shape,
    customer: customerRef,
    share: shareConfig.default(defaultShareConfig),
});
